export default {
  namespaced: true,
  state:{
    context: {
      period: { year: null, month: null },
      window: { open_day: null, close_day: null, is_open: false, closed_reason: null },
      // Generadas las tareas, el período queda cerrado aunque la ventana siga abierta.
      // Es un motivo distinto de "todavía no abre" y no se arregla esperando.
      tasks_generated: false,
      server_date: null,
      clients: []
    },
    catalog: [],
    orders: [],
    orderForm: {
      modal: false,
      clientId: null,
      clientName: '',
      items: [],
      // Lo fija quien abre el formulario: el supervisor según su ventana, el administrador
      // de compras según la suya. El formulario no lo deduce por su cuenta.
      editable: true,
      // Motivo por el que el pedido no admite cambios, para explicárselo al usuario.
      readonlyReason: null,
      // Presupuesto vigente del conjunto, para mostrar el disponible mientras se arma el
      // pedido. Sólo lo usa quien puede ver precios.
      budget: null,
      // Callback opcional para refrescar la pantalla que abrió el formulario, que no siempre
      // es la del supervisor.
      onSaved: null
    },
    logsDialog: {
      modal: false,
      orderId: null,
      logs: []
    }
  },
  getters:{
    context: state => state.context,
    catalog: state => state.catalog,
    orders: state => state.orders,
    orderForm: state => state.orderForm,
    logsDialog: state => state.logsDialog,
    // Un conjunto sin pedido del período todavía puede crearlo; uno con pedido lo edita.
    orderByClient: state => clientId => state.orders.find(o => o.client_id === clientId) || null
  },
  mutations:{
    SET_CONTEXT(state, value){ state.context = value; },
    SET_CATALOG(state, value){ state.catalog = value; },
    SET_ORDERS(state, value){ state.orders = value; },
    SET_ORDER_FORM(state, value){ state.orderForm = Object.assign({}, state.orderForm, value); },
    SET_LOGS_DIALOG(state, value){ state.logsDialog = Object.assign({}, state.logsDialog, value); }
  },
  actions:{
    getContext({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('stock/orders/context').then((response) => {
          commit('SET_CONTEXT', response.data.data);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    getCatalog({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('stock/products').then((response) => {
          commit('SET_CATALOG', response.data.data);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    getOrders({ commit }, payload) {
      const params = payload || {};
      return new Promise((resolve, reject) => {
        axios.get('stock/orders', { params }).then((response) => {
          commit('SET_ORDERS', response.data.data.orders);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    getOrder({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get('stock/orders/' + id).then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    saveOrder({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('stock/orders', payload).then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    getLogs({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get('stock/orders/' + id + '/logs').then((response) => {
          commit('SET_LOGS_DIALOG', { logs: response.data.data });
          resolve(response);
        }).catch(error => reject(error));
      });
    }
  }
}
